import { IConsultant_ECI } from "../../models/Consultant_ECI";

export const EmptyECI: IConsultant_ECI = {
    ecI_ID: undefined,
    req_ID: undefined,
    submission_ID: undefined,
    ecI_Date: undefined,
    ecI_Time: undefined,
    ecI_Time_Zone: 0,
    ecI_Type: null,
    ecI_InterviewrName: undefined,
    ecI_Client: undefined,
    ecI_Feedback_Status: 1,
    comments: undefined,
    email_Subject: ' '
}